import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GiftingIneligibleComponent } from './containers/gifting-ineligible/gifting-ineligible.component';
import { InheritanceIneligibleComponent } from './containers/inheritance-ineligible/inheritance-ineligible.component';
import { InternalTransferIneligibleComponent } from './containers/internal-transfer-ineligible/internal-transfer-ineligible.component';
import { MinorIneligibleComponent } from './containers/minor-ineligible/minor-ineligible.component';

const routes: Routes = [
  {
    path: 'inheritance/ineligible',
    component: InheritanceIneligibleComponent,
    title: 'Ineligible | Vanguard',
    data: {
      pageId: 'inheritance_ineligible',
      accountType: true,
    },
  },
  {
    path: 'multi-inheritance/ineligible',
    component: InheritanceIneligibleComponent,
    title: 'Ineligible | Vanguard',
    data: {
      pageId: 'inheritance_ineligible',
      accountType: true,
    },
  },
  {
    path: 'inherited-ira/ineligible',
    component: InheritanceIneligibleComponent,
    title: 'Ineligible | Vanguard',
    data: {
      pageId: 'inheritance_ineligible',
      accountType: true,
    },
  },
  {
    path: 'minor-transfer/ineligible',
    component: MinorIneligibleComponent,
    title: 'Ineligible | Vanguard',
    data: {
      pageId: 'minor_ineligible',
      accountType: true,
    },
  },
  {
    path: 'gifting/ineligible',
    component: GiftingIneligibleComponent,
    title: 'Ineligible | Vanguard',
    data: {
      pageId: 'gifting_ineligible',
      accountType: true,
    },
  },
  {
    path: 'internal-transfer/ineligible',
    component: InternalTransferIneligibleComponent,
    title: 'Ineligible | Vanguard',
    data: {
      pageId: 'internal-transfer_ineligible',
      accountType: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IneligibleRoutingModule {}
